import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const privacyContent = <>
      <h3 className="text-xl font-bold text-dark mb-4" data-id="element-31">
        Política de Privacidad
      </h3>
      <div className="space-y-4 text-gray-600 text-sm leading-relaxed" data-id="element-32">
        <p data-id="element-33">
          En LOKL MKT, nos comprometemos a proteger tu información personal.
          Esta política describe cómo recopilamos, usamos y protegemos tus
          datos.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-34">Información que recopilamos</h4>
        <p data-id="element-35">
          Recopilamos información que nos proporcionas directamente, como tu
          nombre, correo electrónico, número de teléfono y datos de tu negocio
          cuando solicitas nuestros servicios o te comunicas con nosotros.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-36">Uso de la información</h4>
        <p data-id="element-37">
          Utilizamos tu información para prestarte nuestros servicios de
          marketing digital, comunicarnos contigo sobre tu cuenta, enviarte
          actualizaciones relevantes y mejorar nuestros servicios.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-38">Protección de datos</h4>
        <p data-id="element-39">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información contra acceso no autorizado, alteración o
          destrucción.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-40">Contacto</h4>
        <p data-id="element-41">
          Si tienes preguntas sobre esta política, puedes contactarnos a través
          de nuestros canales de atención.
        </p>
      </div>
    </>;
  const termsContent = <>
      <h3 className="text-xl font-bold text-dark mb-4" data-id="element-42">
        Términos y Condiciones
      </h3>
      <div className="space-y-4 text-gray-600 text-sm leading-relaxed" data-id="element-43">
        <p data-id="element-44">
          Al contratar los servicios de LOKL MKT, aceptas los siguientes
          términos y condiciones.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-45">Servicios</h4>
        <p data-id="element-46">
          LOKL MKT ofrece servicios de diseño web, gestión de redes sociales y
          optimización de presencia digital para negocios locales. Los
          entregables y alcances específicos se detallan en cada propuesta
          individual.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-47">Pagos</h4>
        <p data-id="element-48">
          Los pagos se realizan de forma mensual según el plan contratado. Los
          precios pueden estar sujetos a cambios con previo aviso de 30 días.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-49">Cancelación</h4>
        <p data-id="element-50">
          Puedes cancelar tu suscripción en cualquier momento. No existen
          contratos forzosos a largo plazo. La cancelación será efectiva al
          finalizar el periodo de facturación vigente.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-51">Propiedad intelectual</h4>
        <p data-id="element-52">
          Los diseños y contenidos creados para tu negocio son de tu propiedad
          una vez completado el pago correspondiente. Las herramientas y
          plantillas propias de LOKL MKT permanecen como propiedad de la
          empresa.
        </p>
        <h4 className="font-semibold text-dark" data-id="element-53">
          Limitación de responsabilidad
        </h4>
        <p data-id="element-54">
          LOKL MKT no garantiza resultados específicos, ya que estos dependen de
          múltiples factores. Nos comprometemos a aplicar las mejores prácticas
          de la industria en cada proyecto.
        </p>
      </div>
    </>;
  return <footer className="bg-dark text-gray-400 py-12 border-t border-white/10" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-57">
          <div className="flex flex-col items-center md:items-start" data-id="element-58">
            <img src="https://cdn.magicpatterns.com/uploads/6GE52Wm2byR8iyJxyLfsC1/Logo_LOKL_MKT.png" alt="LOKL MKT - Más clientes. Menos complicaciones." className="h-24 w-auto object-contain mb-3" data-id="element-59" />
            <p className="text-sm" data-id="element-60">
              Impulsando negocios locales al siguiente nivel.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-sm text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-61">
          <p data-id="element-62">&copy; {currentYear} LOKL MKT. Todos los derechos reservados.</p>
          <div className="flex gap-4" data-id="element-63">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors" data-id="element-64">
              Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors" data-id="element-65">
              Términos
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}
      <AnimatePresence data-id="element-66">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-67">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-68" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-6 sm:p-8" onClick={e => e.stopPropagation()} data-id="element-69">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-gray-400 hover:text-dark transition-colors" aria-label="Cerrar" data-id="element-70">
                <XIcon className="w-5 h-5" data-id="element-71" />
              </button>

              {activeModal === 'privacy' ? privacyContent : termsContent}

              <div className="mt-6 pt-4 border-t border-gray-100" data-id="element-72">
                <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-dark text-white rounded-xl font-medium hover:bg-dark/90 transition-colors text-sm" data-id="element-73">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </footer>;
}